/* eslint-disable react/jsx-props-no-spreading */
const CircleWithLine = (props) => (
	<svg width={206} height={206} viewBox="0 0 206 206" {...props}>
		<defs>
			<clipPath id="a">
				<circle cx="103" cy="103" r="103" fill="#fff" data-name="Ellipse 2" />
			</clipPath>
		</defs>
		<g fill="#fff" clipPath="url(#a)" data-name="Mask Group 1">
			<path
				d="M0 0h206v5H0zM0 10h206v5H0zM0 20h206v5H0zM0 30h206v5H0zM0 40h206v5H0zM0 50h206v5H0zM0 60h206v5H0zM0 70h206v5H0zM0 80h206v5H0zM0 90h206v5H0zM0 100h206v5H0zM0 110h206v5H0zM0 120h206v5H0zM0 130h206v5H0zM0 140h206v5H0zM0 150h206v5H0zM0 160h206v5H0zM0 170h206v5H0zM0 180h206v5H0zM0 190h206v5H0zM0 200h206v5H0z"
				data-name="Rectangle 1"
			/>
		</g>
	</svg>
);

export default CircleWithLine;
